import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postTenantGroup } from 'Services';
import { RQ_CREATE_TENANT_GROUP, RQ_TENANT_GROUPS } from 'Utils';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';

type CreateTenantGroupProps = {
    mutationOptions?: {
        onSuccess: any;
        onError: any;
    };
};

function useCreateTenantGroup({ mutationOptions }: CreateTenantGroupProps) {
    const { t } = useTranslation();
    const { addAlert } = useAlertBanner();
    const queryClient = useQueryClient();

    const handleOnSuccess = (variable: TenantGroup) => {
        addAlert({
            id: 'save-tenant-group-success',
            content: t('Save Tenant Group success message', { name: variable.name }),
            status: 'success'
        });
        queryClient.invalidateQueries([RQ_TENANT_GROUPS]);
    };

    const handleOnError = (variable: TenantGroup) => {
        addAlert({
            id: 'save-tenant-group-error',
            content: t('Save Tenant Group error message', { name: variable.name }),
            status: 'danger'
        });
    };

    return useMutation([RQ_CREATE_TENANT_GROUP], postTenantGroup, {
        onSuccess: (_data, variable) => {
            handleOnSuccess(variable);
            mutationOptions?.onSuccess();
        },
        onError: (_data, variable) => {
            handleOnError(variable);
            mutationOptions?.onError();
        }
    });
}

export default useCreateTenantGroup;
